import _ from "lodash";
import moment from "moment";
import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";

import { fetchNetworkAnalytics } from "DashboardNetworkingAction";
export var DASHBOARD_TOTAL_SESSIONS = "DASHBOARD_TOTAL_SESSIONS";
export function fetchSessionAnalytics(session, callback) {
  // debugger;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/app_analytics?filter=eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response.resource;

        var allsessions = _.filter(data, (o) => o.type === "entry");

        var todaysSessions = _.filter(data, function (o) {
          return moment().isSame(moment(o.timestamp), "day");
        });

        //Prepare screen session data overall
        var numsessions = data.length;
        //Pick all unique screen names
        var screens = _.uniq(_.map(data, "screen"));
        var screenData = [];
        screens.map((value, index) => {
          var count = 0;
          data.map((val, id) => {
            if (val.screen === value) {
              count++;
            }
          });
          if (count > 0) {
            screenData.push({
              hits: count,
              percentage: count / numsessions,
              screen: value,
            });
          }
        });

        //Calculating today's sessions

        var validSessions = _.filter(todaysSessions, (o) => o.type === "entry");
        var numTodaysSessions = validSessions.length;
        //Pick all unique screen names
        var screensToday = _.uniq(_.map(validSessions, "screen"));
        var todaysScreenData = [];
        screensToday.map((value, index) => {
          var count = 0;
          validSessions.map((val, id) => {
            if (val.screen === value) {
              count++;
            }
          });
          if (count > 0) {
            var percentage = Math.floor((count / numTodaysSessions) * 100.0);
            todaysScreenData.push({
              name: `${percentage}% ${_.upperFirst(value)}`,
              value: count,
            });
          }
        });

        //callback({error:0,data:{response:{screenData,todaysScreenData},count:allsessions.length}});
        dispatch({
          type: DASHBOARD_TOTAL_SESSIONS,
          payload: {
            response: { screenData, todaysScreenData },
            count: allsessions.length,
          },
        });
        dispatch(fetchNetworkAnalytics(session, callback));
      },
      (error) => {
        callback({ error: 1, data: [] });
      }
    );
  };
}

export function fetchSessionAnalytics1(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=fetchSessionAnalytics`;

  return (dispatch) => {
    postRequest(
      url,
      {
        type: "fetchSessionAnalytics",
        types: "entry",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        var validSessions = data.sessionliststoday;
        var numTodaysSessions = validSessions.length;

        //Prepare screen session data overall
        var numsessions = numTodaysSessions;

        //Pick all unique screen names
        var screens = data.sessionlists;
        var screenData = [];
        screens.map((value, index) => {
          screenData.push({
            hits: value.hits,
            percentage: parseInt(value.hits) / numsessions,
            screen: value.screen,
          });
        });

        //Calculating today's sessions

        var numTodaysSessions = _.sumBy(validSessions, function (o) {
          return parseInt(o.hits);
        });
        //Pick all unique screen names
        var screensToday = data.sessionliststoday;
        var todaysScreenData = [];
        screensToday.map((value, index) => {
          var percentage = Math.floor(
            (parseFloat(value.hits) / numTodaysSessions) * 100.0
          );
          todaysScreenData.push({
            name: `${percentage}% ${_.upperFirst(value.screen)}`,
            value: parseInt(value.hits),
          });
        });

        dispatch({
          type: DASHBOARD_TOTAL_SESSIONS,
          payload: {
            response: { screenData, todaysScreenData },
            count: data.count,
          },
        });

        callback({ error: 0, data: "Session Analytics Data Fetched" });
      },
      (error) => {
        callback({ error: 1, data: [] });
      }
    );
  };
}

export function fetchSessionAnalyticsNew(session, callback) {
  // debugger;
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=fetchSessionAnalytics&eventid=${session.eventid}`;
  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/app_analytics?filter=eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response.resource;

        var allsessions = _.filter(data, (o) => o.type === "entry");

        var todaysSessions = _.filter(data, function (o) {
          return moment().isSame(moment(o.timestamp), "day");
        });

        //Prepare screen session data overall
        var numsessions = data.length;
        //Pick all unique screen names
        var screens = _.uniq(_.map(data, "screen"));
        var screenData = [];
        screens.map((value, index) => {
          var count = 0;
          data.map((val, id) => {
            if (val.screen === value) {
              count++;
            }
          });
          if (count > 0) {
            screenData.push({
              hits: count,
              percentage: count / numsessions,
              screen: value,
            });
          }
        });

        //Calculating today's sessions

        var validSessions = _.filter(todaysSessions, (o) => o.type === "entry");
        var numTodaysSessions = validSessions.length;
        //Pick all unique screen names
        var screensToday = _.uniq(_.map(validSessions, "screen"));
        var todaysScreenData = [];
        screensToday.map((value, index) => {
          var count = 0;
          validSessions.map((val, id) => {
            if (val.screen === value) {
              count++;
            }
          });
          if (count > 0) {
            var percentage = Math.floor((count / numTodaysSessions) * 100.0);
            todaysScreenData.push({
              name: `${percentage}% ${_.upperFirst(value)}`,
              value: count,
            });
          }
        });

        //callback({error:0,data:{response:{screenData,todaysScreenData},count:allsessions.length}});
        dispatch({
          type: DASHBOARD_TOTAL_SESSIONS,
          payload: {
            response: { screenData, todaysScreenData },
            count: allsessions.length,
          },
        });
        // dispatch(fetchNetworkAnalytics(session,callback));

        callback({ error: 0, data: "Session Analytics Data Fetched" });
      },
      (error) => {
        callback({ error: 1, data: [] });
      }
    );
  };
}
